import { render } from "./Contacto.vue?vue&type=template&id=3e9133de"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"
script.render = render

export default script